
export const getMiscData = args => {
  const { type, callbacks } = args;

  return {
    type,
    path: '/misc',
    method: 'GET',
    ...callbacks,
  };
};